import styled from 'styled-components';

const IconButtonStyle = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 4px;
  border-radius: 50%;

  cursor: pointer;
  &:hover {
    background-color: #b34cff0a;
  }
`;

export const IconButton = (props) => {
  const { children, ...others } = props;
  return <IconButtonStyle {...others}>{children}</IconButtonStyle>;
};
